import React from 'react';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as VerifiedUsers } from './verified_users.svg';
import { COLOR_TO_HEX_MAPPING } from '../../../constants/app-constants';

const KeyValueReport = ({ reportData }) => {
    const { title, value, guaranteed, colour } = reportData || {};
    return (
        <Stack direction='row' gap={1} alignItems='start' className={`mb-3 w-full`}>
            <div className={`flex justify-between w-full`}>
                <Typography variant="body1" className='flex items-center'>
                    {guaranteed && <VerifiedUsers className='h-4 w-4 text-success mr-2'/>}
                    <span>{title}</span>
                </Typography>
                <Typography variant="body1" className='opacity-70 font-bold text-end' style={{color: COLOR_TO_HEX_MAPPING[colour]}} >
                    {value}
                </Typography>
            </div>
        </Stack>
    );
};

KeyValueReport.propTypes = {
    reportData: PropTypes.object
};

export default KeyValueReport;
